import { IntelligentPrompt } from "../ChatBox/ChatBloc";
import ChatBoxV3 from "../ChatBox/ChatBoxV3";

export function GenUI(props: any) {
  const intelligentPrompt = IntelligentPrompt.genUI;
  return <ChatBoxV3 {...props} intelligentPrompt={intelligentPrompt} />;
}
